import React from "react";
import FooterPanel from "./FooterPanel";
import { IButtonStyles, PrimaryButton } from "@fluentui/react/lib/Button";
import { ButtonVariants } from "../../styles/fluent/ButtonVariants";
import HeaderPanel from "./HeaderPanel";
import { mergeStyleSets, Modal } from "@fluentui/react";
import { ColorVariantsMap, contentStyles, ModalAction, ModalVariantsEnum } from "./ActionModal";
import { generateIdentifier } from "../../utils/helpers/RobotFramework";
import { multiline } from "../../utils/helpers/LanguageHelper";

const standaloneClassNames = mergeStyleSets({
  message: {
    fontSize: "1rem",
    fontWeight: "normal",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    color: "var(--color-blue)",
    padding: "1rem 1rem 0 1rem",
  },
  icon: {
    width: "220px",
    height: "150px",
    objectFit: "contain",
  },
  iconWrapper: { margin: "5rem auto 1.5rem auto", display: "flex", justifyContent: "center" },
});

const standaloneButtonStyles: IButtonStyles = {
  root: { height: "auto", minHeight: "32px", minWidth: 0, padding: "6px 12px" },
  label: { whiteSpace: "normal", lineHeight: "1.2" },
  textContainer: { whiteSpace: "normal" },
};

export interface StandaloneModalProps {
  modalTitle: string;
  icon: string;
  alt?: string;
  message: any;
  type: ModalVariantsEnum;
  actions: ModalAction[];
  onHide?: () => void;
}

export const StandaloneModal: React.FunctionComponent<StandaloneModalProps> = (props) => {
  const { modalTitle, icon, alt, message, type, actions, onHide } = props;

  return (
    <Modal titleAriaId={"titleId"} isOpen={true} containerClassName={contentStyles.container}>
      <HeaderPanel applyPadding borderColor={ColorVariantsMap[type]}>
        {modalTitle}
      </HeaderPanel>
      <div className={standaloneClassNames.iconWrapper}>
        <img alt={alt} src={icon} className={standaloneClassNames.icon} />
      </div>

      <div>
        <span className={standaloneClassNames.message}>
          {typeof message == "string" ? multiline(message) : message}
        </span>
      </div>

      <FooterPanel>
        <div
          className="ms-Grid-col ms-xs12 ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            gap: "12px",
            width: "100%",
          }}
        >
          {actions.map((action, index) => (
            <PrimaryButton
              id={action.id}
              data-testid={action.id}
              text={action.title}
              onClick={() => {
                action.onClick?.();
                onHide?.();
              }}
              disabled={action.disabled}
              key={generateIdentifier("action", index.toString())}
              className={ButtonVariants[action.variant]}
              style={action.style}
              styles={standaloneButtonStyles}
            />
          ))}
        </div>
      </FooterPanel>
    </Modal>
  );
};
